import React from 'react';

interface ProgressBarProps {
  current: number;
  total: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ current, total }) => {
  const percentage = Math.round((current / total) * 100);

  return (
    <div className="p-4 bg-gray-50 border-b border-gray-200">
      <div className="flex items-center justify-between mb-2">
        <span className="text-sm font-medium text-gray-700">
          Question {current} sur {total}
        </span>
        <span className="text-sm font-medium text-gray-700">
          {percentage}%
        </span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-2">
        <div 
          className="h-2 rounded-full transition-all duration-300 ease-in-out"
          style={{ 
            width: `${percentage}%`,
            background: 'linear-gradient(135deg, rgb(20, 184, 166) 0%, rgb(59, 130, 246) 100%)'
          }}
        ></div>
      </div>
    </div>
  );
};

export default ProgressBar;